var map = {
	"./": 485,
	"./OldUi": 2666,
	"./OldUi.js": 2666,
	"./SpireonNew": 2667,
	"./SpireonNew.js": 2667,
	"./SpireonOld": 2668,
	"./SpireonOld.js": 2668,
	"./index": 485,
	"./index.js": 485,
	"./style": 373,
	"./style.js": 373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4169;